import {Button, Kbd, Tooltip, Typography} from "@heroui/react";
import {RedoIcon} from "@project/icons-web";

import {useThemeBuilder} from "./theme-builder-context";

/* ------------------------------------------------------------------------------------------------
 * RedoButton
 * Steps forward through the theme history. Disabled when at the latest snapshot.
 * ------------------------------------------------------------------------------------------------ */
export function RedoButton() {
  const {canRedo, redo} = useThemeBuilder();

  return (
    <Tooltip closeDelay={0} delay={100}>
      <Tooltip.Trigger>
        <Button isIconOnly isDisabled={!canRedo} size="md" variant="tertiary" onPress={redo}>
          <RedoIcon />
        </Button>
      </Tooltip.Trigger>
      <Tooltip.Content className="flex items-center gap-2">
        <Tooltip.Arrow />
        <Typography>Redo</Typography>
        <Kbd>
          <Kbd.Abbr keyValue="command" />
          <Kbd.Content>Y</Kbd.Content>
        </Kbd>
      </Tooltip.Content>
    </Tooltip>
  );
}
